import Dropdown from 'ui/Dropdown'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Content, Earning, Price, Purchases, ReleaseDate, Status } from '../columns'
import { Table } from 'ui'

const RowContent = ({
  uuid,
  serieUUID,
  cover,
  title,
  serieTitle,
  seasonNumber,
  episodeNumber,
  isSerie,
  status,
  releaseDate,
  purchases,
  price,
  earnings,
  isShutDown
}) => {

  const { t } = useTranslation()

  return (
    <Table.Row>
      <Table.Column>
        <Content
          cover={cover}
          title={title}
          serie={serieTitle}
          season={seasonNumber}
          episode={episodeNumber}
          isSerie={isSerie}
        />
      </Table.Column>

      <Table.Column>
        <Status status={status} />
      </Table.Column>
  
      <Table.Column>
        <ReleaseDate
          status={status}
          date={releaseDate}
        />
      </Table.Column>

      <Table.Column>
        <Purchases
          status={status}
          purchases={purchases}
        />
      </Table.Column>

      <Table.Column>
        <Price
          status={status}
          price={price}
        />
      </Table.Column>

      <Table.Column>
        <Earning
          status={status}
          earnings={earnings}
        />
      </Table.Column>

      <Table.Column>
        <Dropdown
          isShutDown={isShutDown}
          options={[
            {
              label: t('viewOnFlixxo'),
              to: isSerie
                ? `/series/${serieUUID}`
                : `/community/${uuid}`
            }
          ]}
        />
      </Table.Column>

    </Table.Row>
  )
}

export default RowContent